module.exports = __webpack_public_path__ + "img/rgg_logo_erb.2018a966.png";